import styles from './index.module.scss';
import { defineComponent, h } from 'vue';
import { small_height, utility } from '@phi/components';
import { Flex } from '@phi/components/layout';
import { PhiLogoWithlabel } from '../phi-logo-with-label';
import { PhiEarphones } from '../phi-earphones';

export const Page = defineComponent({
    props: {
        light: { required: false, type: Boolean, default: true }
    },

    setup(props, { slots }) {
        return () => h(Flex, {
            equally: true,
            direction: 'row',
            class: [ utility.entire_screen ],
            gap: 'none',
        }, () => [
            h('section', {
                class: [
                    utility.flex,
                    utility.direction_column,
                    utility.overflow,
                ]
            }, [
                h('header', {
                    class: {
                        [utility.p_2]: small_height(),
                        [utility.p_5]: !small_height(),
                    },
                }, h('a', {
                    href: 'https://phi3d.com',
                    target: '_blank',
                    class: utility.unstyled,
                }, PhiLogoWithlabel(props.light))),

                h('section', { class: [ styles.form, utility.m_auto ]},
                    slots.default ? slots.default() : undefined,
                ),
            ]),

            h('aside', { class: [ styles.earphones, utility.h_100 ] },
                slots.aside ? slots.aside() : PhiEarphones),
        ]);
    },
});
